import Calc from "@/common/util/calculator"
import BaseScrewFixmethod from "@/signomatic/app/fixmethods/base_screw"

export default class ScrewWoodFixmethod extends BaseScrewFixmethod {
  positions() {
    const { shape, widthPx, width, heightPx, height } = this.state
    const positions = []
    const cappedScrew = this.state.fixmethod === "screw_capped"
    const diameter = Calc.mmToPx(4.3)
    const headDiameter = cappedScrew ? Calc.mmToPx(15) : Calc.mmToPx(8)
    let distance = 0
    let min = 0
    let max = 0

    const hasBorder = this.drawables.hasBorder
    const defaults = { diameter, headDiameter }
    const center = widthPx / 2 - diameter / 2
    const centerV = heightPx / 2 - diameter / 2

    if (shape === "rect") {
      if (width >= 1000) {
        if (cappedScrew) {
          distance = this.drawables.sizeRelative("width", Calc.mmToPx(25), Calc.mmToPx(35), {
            minWidth: 1000,
          })
        } else {
          distance = this.drawables.sizeRelative("width", Calc.mmToPx(20), Calc.mmToPx(30), {
            minWidth: 1000,
          })
        }

        const left = distance - diameter / 2
        const top = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance
        const bottom = heightPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
        positions.push({ ...defaults, left: center, top })
        positions.push({ ...defaults, left: center, top: bottom })
      } else if (height >= 100) {
        min = cappedScrew ? Calc.mmToPx(15) : Calc.mmToPx(hasBorder ? 10 : 8)
        max = cappedScrew ? Calc.mmToPx(25) : Calc.mmToPx(20)
        distance = this.drawables.sizeRelative("height", min, max, {
          minHeight: 100,
        })

        const left = distance - diameter / 2
        const top = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance
        const bottom = heightPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        min = cappedScrew ? Calc.mmToPx(11) : Calc.mmToPx(hasBorder ? 7 : 5)
        max = cappedScrew ? Calc.mmToPx(15) : Calc.mmToPx(hasBorder ? 10 : 8)
        distance = this.drawables.sizeRelative("height", min, max, {
          maxHeight: 99,
        })

        const left = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    } else if (shape === "round") {
      if (width >= 1000 && height >= 500) {
        distance = this.drawables.sizeRelative("width", Calc.mmToPx(hasBorder ? 42 : 32), Calc.mmToPx(55), {
          minWidth: 1000,
        })

        const left = distance - diameter / 2
        const top = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance
        const bottom = heightPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
        positions.push({ ...defaults, left: center, top })
        positions.push({ ...defaults, left: center, top: bottom })
      } else if (width >= 1000) {
        distance = this.drawables.sizeRelative("height", Calc.mmToPx(16), Calc.mmToPx(hasBorder ? 35 : 28), {
          maxHeight: 499,
        })

        const left = distance - diameter / 2
        const top = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance
        const bottom = heightPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
        positions.push({ ...defaults, left: center, top })
        positions.push({ ...defaults, left: center, top: bottom })
      } else if (height >= 100) {
        min = cappedScrew ? Calc.mmToPx(15) : Calc.mmToPx(hasBorder ? 10 : 8)
        distance = this.drawables.sizeRelative("height", min, Calc.mmToPx(50), {
          minHeight: 100,
        })

        const left = distance - diameter / 2
        const top = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance
        const bottom = heightPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        min = cappedScrew ? Calc.mmToPx(11) : Calc.mmToPx(hasBorder ? 7 : 5)
        max = cappedScrew ? Calc.mmToPx(15) : Calc.mmToPx(hasBorder ? 10 : 8)
        distance = this.drawables.sizeRelative("height", min, max, {
          maxHeight: 99,
        })

        const left = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    } else if (shape === "thorny") {
      if (width >= 600) {
        distance = this.drawables.sizeRelative("width", Calc.mmToPx(50), Calc.mmToPx(120), {
          minWidth: 600,
        })
        const left = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance

        const topdistance = this.drawables.sizeRelative("width", Calc.mmToPx(50), Calc.mmToPx(72), {
          minWidth: 600,
        })
        const top = topdistance - diameter / 2
        const bottom = heightPx - diameter / 2 - topdistance

        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
        positions.push({ ...defaults, left: center, top })
        positions.push({ ...defaults, left: center, top: bottom })
      } else {
        min = cappedScrew ? Calc.mmToPx(12) : Calc.mmToPx(6)
        max = Calc.mmToPx(50)

        distance = this.drawables.sizeRelative("width", min, max, { maxWidth: 600 })

        const left = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    } else if (["ellipse", "stop"].includes(shape)) {
      if (width >= 600) {
        if (shape === "ellipse") {
          min = Calc.mmToPx(hasBorder ? 15 : 12)
          max = Calc.mmToPx(20)
        } else if (shape === "stop") {
          min = Calc.mmToPx(16)
          max = Calc.mmToPx(20)
        }

        distance = this.drawables.sizeRelative("width", min, max, { minWidth: 600 })

        const left = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance
        const top = distance - diameter / 2
        const bottom = heightPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
        positions.push({ ...defaults, left: center, top })
        positions.push({ ...defaults, left: center, top: bottom })
      } else {
        if (shape === "ellipse") {
          min = cappedScrew ? Calc.mmToPx(11) : Calc.mmToPx(hasBorder ? 7 : 5)
          max = cappedScrew ? Calc.mmToPx(18) : Calc.mmToPx(hasBorder ? 15 : 12)
        } else if (shape === "stop") {
          min = cappedScrew ? Calc.mmToPx(11) : Calc.mmToPx(hasBorder ? 8 : 7)
          max = Calc.mmToPx(16)
        }

        distance = this.drawables.sizeRelative("height", min, max)

        const left = distance - diameter / 2
        const right = widthPx - diameter / 2 - distance

        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    } else if (shape === "rotated_rect") {
      if (cappedScrew) {
        distance =
          height < 100
            ? this.drawables.sizeRelative("height", Calc.mmToPx(12), Calc.mmToPx(17), { maxHeight: 100 })
            : this.drawables.sizeRelative("height", Calc.mmToPx(17), Calc.mmToPx(50), {
                minHeight: 100,
                maxHeight: 600,
              })
      } else {
        distance =
          height < 100
            ? this.drawables.sizeRelative("height", Calc.mmToPx(7), Calc.mmToPx(10), { maxHeight: 100 })
            : this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(50), {
                minHeight: 100,
                maxHeight: 600,
              })
      }

      const top = distance - diameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = distance - diameter / 2
      const right = widthPx - diameter / 2 - distance

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })

      if (height > 99) {
        positions.push({ ...defaults, left: center, top: top })
        positions.push({ ...defaults, left: center, top: bottom })
      }
    } else if (["direction_left", "direction_right"].includes(shape)) {
      const distanceFront = cappedScrew
        ? this.drawables.sizeRelative("width", Calc.mmToPx(14), Calc.mmToPx(30), { maxWidth: 590 })
        : this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(20), { maxWidth: 590 })
      const distanceBack = cappedScrew
        ? this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(15), { maxWidth: 590 })
        : this.drawables.sizeRelative("width", Calc.mmToPx(4), Calc.mmToPx(8), { maxWidth: 590 })

      const centerV = heightPx / 2 - diameter / 2
      let left = distanceFront - diameter / 2
      let right = widthPx - diameter / 2 - distanceBack

      if (shape === "direction_right") {
        left = distanceBack - diameter / 2
        right = widthPx - diameter / 2 - distanceFront

        positions.push({
          ...defaults,
          left: widthPx - diameter / 2 - distanceBack,
          top: centerV,
          stretch: true,
        })
      } else {
        positions.push({
          ...defaults,
          left: distanceBack - diameter / 2,
          top: centerV,
          stretch: true,
        })
      }

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (shape === "arrow_left" || shape === "arrow_right") {
      const minFront = cappedScrew ? Calc.mmToPx(14) : Calc.mmToPx(7)
      const maxFront = cappedScrew ? Calc.mmToPx(30) : Calc.mmToPx(25)
      const minBack = cappedScrew ? Calc.mmToPx(10) : Calc.mmToPx(4)
      const maxBack = cappedScrew ? Calc.mmToPx(15) : Calc.mmToPx(15)

      const distanceFront = this.drawables.sizeRelative("height", minFront, maxFront)
      const distanceBack = this.drawables.sizeRelative("height", minBack, maxBack)

      let left = distanceFront - diameter / 2
      let right = widthPx - diameter / 2 - distanceBack

      if (shape === "arrow_right") {
        left = distanceBack - diameter / 2
        right = widthPx - diameter / 2 - distanceFront

        positions.push({
          ...defaults,
          left: widthPx - diameter / 2 - distanceBack,
          top: centerV,
          stretch: true,
        })
      } else {
        positions.push({
          ...defaults,
          left: distanceBack - diameter / 2,
          top: centerV,
          stretch: true,
        })
      }

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (shape === "triangle") {
      min = cappedScrew ? Calc.mmToPx(10) : Calc.mmToPx(hasBorder ? 5.5 : 5.5)
      max = Calc.mmToPx(hasBorder ? 25 : 19)
      distance = this.drawables.sizeRelative("height", min, max)

      const offset = Calc.triangleHorizontalOffset(widthPx, heightPx, distance)
      const minTop = Calc.mmToPx(hasBorder ? 15 : 10)
      const maxTop = Calc.mmToPx(hasBorder ? 25 : 22)
      const distanceTop = this.drawables.sizeRelative("height", minTop, maxTop)

      const top = distanceTop - diameter / 2
      const topStretch = distance - headDiameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = offset + distance - diameter / 2
      const right = widthPx - offset - diameter / 2 - distance

      positions.push({ ...defaults, left: center, top })
      positions.push({ ...defaults, left, top: bottom })
      positions.push({ ...defaults, left: right, top: bottom })
      positions.push({ ...defaults, left: center, top: topStretch, stretch: true })
    } else if (["rounded_top", "rounded_sides", "curved_top", "arched_top"].includes(shape)) {
      let distanceSide = 0
      let distanceTop = 0

      const fourScrews = height >= 199
      const relOptions = { minHeight: 199, minWidth: 199 }
      if (cappedScrew) {
        if (fourScrews) {
          if (shape == "arched_top") {
            distanceSide = Calc.mmToPx(11)
            distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(80), Calc.mmToPx(218), relOptions)
          } else if (shape == "rounded_top") {
            distanceSide = Calc.mmToPx(11)
            distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(28), Calc.mmToPx(67), relOptions)
          } else if (shape == "rounded_sides") {
            distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(27), Calc.mmToPx(68), relOptions)
            distanceTop = Calc.mmToPx(11)
          } else if (shape == "curved_top") {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(11), Calc.mmToPx(13), relOptions)
            const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(82), Calc.mmToPx(244), relOptions)

            const left = distance - diameter / 2
            const top = distance - diameter / 2
            const right = widthPx - distance - diameter / 2
            const bottom = heightPx - Calc.mmToPx(11) - diameter / 2

            positions.push({ ...defaults, left, top })
            positions.push({ ...defaults, left, top: bottom })
            positions.push({ ...defaults, left: right, top: curveTop })
            positions.push({ ...defaults, left: right, top: bottom })

            return positions
          }
        } else {
          distanceSide = Calc.mmToPx(11)
        }
      } else {
        if (fourScrews) {
          if (shape == "arched_top") {
            distanceSide = Calc.mmToPx(11)
            distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(77), Calc.mmToPx(218), relOptions)
          } else if (shape == "rounded_top") {
            distanceSide = Calc.mmToPx(10)
            distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(24), Calc.mmToPx(67), relOptions)
          } else if (shape == "rounded_sides") {
            distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(27), Calc.mmToPx(68), relOptions)
            distanceTop = Calc.mmToPx(10)
          } else if (shape == "curved_top") {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(13), relOptions)
            const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(82), Calc.mmToPx(244), relOptions)

            const left = distance - diameter / 2
            const top = distance - diameter / 2
            const right = widthPx - distance - diameter / 2
            const bottom = heightPx - Calc.mmToPx(10) - diameter / 2

            positions.push({ ...defaults, left, top })
            positions.push({ ...defaults, left, top: bottom })
            positions.push({ ...defaults, left: right, top: curveTop })
            positions.push({ ...defaults, left: right, top: bottom })

            return positions
          }
        } else {
          distanceSide = Calc.mmToPx(9.5)
        }
      }

      const left = distanceSide - diameter / 2
      let top = distanceTop - diameter / 2
      let bottom = heightPx - distanceTop - diameter / 2
      const right = widthPx - distanceSide - diameter / 2
      let centerV = widthPx / 2 - diameter / 2

      if (shape == "arched_top" && fourScrews) {
        top = distanceTop - diameter / 2
        bottom = heightPx - distanceSide - diameter / 2
        positions.push({
          ...defaults,
          left: widthPx / 2 - diameter / 2,
          top: diameter / 2,
          stretch: true,
        })
      } else if (shape == "arched_top") {
        // arcH constant also in arched_top
        const arcH = heightPx * 0.35
        const squareHeight = heightPx - arcH
        centerV = arcH + squareHeight / 2 - diameter / 2
        positions.push({
          ...defaults,
          left: widthPx / 2 - diameter / 2,
          top: heightPx - centerV - diameter,
          stretch: true,
        })
      }

      if (fourScrews) {
        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    }

    return positions
  }
}
